import { createStyles, makeStyles } from '@mui/styles'

export const useStyles = makeStyles(() =>
  createStyles({
    modalPDF: {
      width: '100%',
      height: '720px',
      zoom: '0.8',
      MozTransformOrigin: '0 0',
      overflow: 'hidden'
    }
  })
)
